export function heroAnimationSlider() {
    const $window = $(window);
    const $body = $("body");
    const $animationSlider = $(".hero-animation-slider");
    const scrollButton = $animationSlider.find(".hero-custom-scroll");
    const $animationSliderItem = $animationSlider.find(".hero-animation-item");
    const $animationSliderNavItem = $animationSlider.find(".hero-animation-slider-nav .hero-animation-slider-nav-item");
    let lengthItems = $animationSliderNavItem.length;

    $window.on("scroll", function () {
        if ($window.scrollTop() <= 0) {
            $("html, body").removeClass("normal-scroll");
            $body.addClass("full-page-init");
            setTimeout(function () {
                $animationSlider.removeClass("hide");
                $.fn.pagepiling.moveTo(lengthItems - 1);
            }, 700);
        }
    });
    scrollButton.append("<i class='circle'></i>");
    $("html, body").addClass("normal-scroll");
    window.scrollTo(0, 0);
    $('.hero-animation-slider-nav').pagepiling({
        menu: null,
        sectionSelector: '.hero-animation-slider-nav-item',
        afterRender: function () {
            window.scrollTo(0, 0);
            $("html, body").removeClass("normal-scroll");
            $body.addClass("full-page-init");
        },
        afterLoad: function (anchorLink, index) {
        },
        onLeave: function (index, nextIndex, direction) {
            $animationSliderItem.eq(nextIndex - 1).addClass("active").next().removeClass("active");
            if (index > lengthItems - 2 && direction == 'down') {
                setTimeout(function () {
                    $("html, body").addClass("normal-scroll");
                    $animationSlider.addClass("hide");
                    window.scrollTo(0, 10);
                    $body.removeClass("full-page-init");
                }, 500);
            } else {
                $body.addClass("full-page-init");
            }
            $animationSlider.find(".circle").css({
                "transform": "rotate(" + (nextIndex - 1) * 45 + "deg)"
            });
        }
    });
    scrollButton.on("click", function () {
        $.fn.pagepiling.moveSectionDown();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroAnimationSlider.js